import React from 'react'
import { PhoneValidationSuccessTemplate } from '../../templates/PhoneValidationSuccessTemplate'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { breakpoints } from '../../../util/medias'

const ContentWrapper = styled.div`
  @media (min-width: ${breakpoints['mobile'] + 1}px) and (max-width: ${breakpoints['tablet']}px) {
    width: 80vw;
  }
`

const PhoneValidationSuccessPage = ({ onSuccess, showRemovedAdsMessage }) => {
  return (
    <ContentWrapper>
      <PhoneValidationSuccessTemplate
        onSuccess={onSuccess}
        showRemovedAdsMessage={showRemovedAdsMessage}
      />
    </ContentWrapper>
  )
}
PhoneValidationSuccessPage.propTypes = {
  onSuccess: PropTypes.func,
}

export { PhoneValidationSuccessPage }
